module.exports = __webpack_public_path__ + "png/logo-quick-registration.png?7d74e0036242c429c3ff964c86dff122";